function decodeJwtPayload(token: string): any {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      return null;
    }

    const payload = parts[1];
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(decoded);
  } catch (error) {
    return null;
  }
}

// Check if a JWT token is expired, with an optional margin in seconds.
// If the token has no expiration time or is otherwise invalid, it is considered expired.
export function isTokenExpired(token: string, margin_sec: number = 30): boolean {
  const payload = decodeJwtPayload(token);

  if (!payload || !payload.exp) {
    return true; // If there's no expiration time, consider it expired
  }

  const currentTime = Math.floor(Date.now() / 1000);
  const expiryTime = payload.exp;
  const expired = currentTime >= (expiryTime - margin_sec);

  return expired;
}
